import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ["input", "submitter"]
  static values = {
    skipValidation: Boolean
  }

  inputTargetConnected(element) {
    element.addEventListener("change", () => this.submitForm())
  }

  submitForm() {
    if (!this.hasInputTarget) return;
    const shouldSkipValidation = this.skipValidationValue;
    const form = this.inputTarget.form;
    
    if (form) {
      const noValidate = form.noValidate;
      if (shouldSkipValidation) {
        form.noValidate = true;
      };
      form.requestSubmit()
      if (shouldSkipValidation) form.noValidate = noValidate;
    }
  }
}
